<div class="grid grid-cols-9 p-3 " [class.border-b-2]="!last" [class.border-[#27368A]]="!last">
  <div class="col-span-6">
    <h4 class="uppercase font-bold text-base">{{ bookingServiceData.service_profile?.service?.name }} - {{
      bookingServiceData.service_profile?.name }} </h4>
    <p class="font-semibold text-sm ">
      Personas: {{ bookingServiceData.units }} <br>
      Cliente: {{ bookingServiceData.booking?.customer?.name }}  <br>
      Reserva: {{ bookingServiceData.booking?.reference }}  <br>
      Fecha y hora: {{ formatDate(bookingServiceData.date) }} - {{ bookingServiceData.hour }}

    </p>
  </div>
  <div class="col-span-3">
    <button (click)="openConsult()"
      class="rounded-lg bg-[#429DCF] w-full text-white text-center font-semibold text-sm">Consultar</button>
    <!-- <p class="text-center  text-white font-semibold text-sm mt-1" [ngStyle]="{ 'background-color' : selectColour }">{{ bookingData.status_booking }}</p> -->
  </div>
</div>



<div *ngIf="consultBookingService"
  class="w-[800px] border-2 border-[#27368A] bg-white left-[20%] top-[20%] overflow-hidden absolute z-10 px-4 pb-3">
  <div class="flex flex-col m-0 pt-3 ">
    <div class="flex justify-end items-start ">
      <button (click)="closeConsultBooking()"
        class="button-close h-6 w-6 flex items-center justify-center bg-transparent rounded-full hover:bg-[#cdd6dabd]">
        <svg class="h-5 w-5 text-[#6c757d]" width="24" height="24" viewBox="0 0 24 24" stroke-width="1"
          stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
          <path stroke="none" d="M0 0h24v24H0z" />
          <line x1="18" y1="6" x2="6" y2="18" />
          <line x1="6" y1="6" x2="18" y2="18" />
        </svg>
      </button>
    </div>
  </div>

  <div class="flex flex-row mb-2 gap-1">
    <p class="text-[#27368A] font-extrabold text-xl ">RESERVA:</p>
    <p class="text-red-600 font-bold text-xl">#{{ bookingServiceData.booking?.reference }}</p>
    <p class="text-gray-400 text-base flex items-end ">
      (oficina {{ bookingServiceData.booking?.office?.name || 'Sin oficina' }})
    </p>
  </div>

  <div class="mb-4">
    <p class="text-[#27368A] font-extrabold text-lg">Fecha y hora reservadas</p>
    <p class="text-[#8A8A8A] font-bold text-base">{{ formatDate(bookingServiceData.date) }} - {{ bookingServiceData.hour
      }}</p>
  </div>

  <div class="grid grid-cols-2 mb-3">

    <div>
      <div class="mb-4">
        <p class="text-[#27368A] font-extrabold text-lg">Datos Reserva</p>
        <div class="flex flex-row gap-1">
          <p class="text-[#8A8A8A] font-bold text-base">Servicio: </p>
          <p class="text-[#8A8A8A] text-base"> {{ bookingServiceData.service_profile?.service?.name }}</p>
        </div>
        <div class="flex flex-row gap-1">
          <p class="text-[#8A8A8A] font-bold text-base">Personas:</p>
          <p class="text-[#8A8A8A] text-base">{{ bookingServiceData.booking?.seats }}</p>
        </div>
        <!-- <div class="flex flex-row gap-1">
          <p class="text-[#8A8A8A] font-bold text-base">Zona:</p>
          <p class="text-[#8A8A8A] text-base"></p>
        </div> -->
      </div>

      <div class="mb-4">
        <p class="text-[#27368A] font-extrabold text-lg">Datos Titular</p>
        <div class="flex flex-row gap-1">
          <p class="text-[#8A8A8A] font-bold text-base">Nombre completo:</p>
          <p class="text-[#8A8A8A] text-base">{{ bookingServiceData.booking.customer?.name }}</p>
        </div>
        <div class="flex flex-row gap-1">
          <p class="text-[#8A8A8A] font-bold text-base">DNI:</p>
          <p class="text-[#8A8A8A] text-base">{{ bookingServiceData.booking.customer?.cif }}</p>
        </div>
        <div class="flex flex-row gap-1">
          <p class="text-[#8A8A8A] font-bold text-base">Teléfono:</p>
          <p class="text-[#8A8A8A] text-base">{{ bookingServiceData.booking.customer?.phone }}</p>
        </div>
        <div class="flex flex-row gap-1">
          <p class="text-[#8A8A8A] font-bold text-base">Email:</p>
          <p class="text-[#8A8A8A] text-base">{{ bookingServiceData.booking.customer?.email }}</p>
        </div>
      </div>
    </div>

    <div>
      <div class="mb-14">
        <div class="grid grid-cols-2 align-middle items-center gap-1">
          <p class="text-[#27368A] font-extrabold text-lg">Importe total: </p>
          <p class="text-[#8A8A8A] font-bold text-base">{{ bookingServiceData.booking?.total_amount }}€</p>
        </div>
        <div class="grid grid-cols-2 mb-4">
          <p class="text-[#27368A] font-extrabold text-lg">Estado</p>
          <p
            class="text-center text-white font-semibold text-base mt-1 rounded-md"
            [ngClass]="bookingServiceData.booking?.status?.color"
            [ngStyle]="{ 'color': 'white' }"
          >
            {{ bookingServiceData.booking?.status?.status }}
          </p>
        </div>
      </div>

      <div class="mb-4">
        <p class="text-[#27368A] font-extrabold text-lg">Datos de facturación</p>
        <div class="flex flex-row gap-1">
          <p class="text-[#8A8A8A] font-bold text-base">Razón social:</p>
          <p class="text-[#8A8A8A] text-base">{{ bookingServiceData.booking.customer?.name }}</p>
        </div>
        <div class="flex flex-row gap-1">
          <p class="text-[#8A8A8A] font-bold text-base">DNI/CIF:</p>
          <p class="text-[#8A8A8A] text-base">{{ bookingServiceData.booking.customer?.cif }}</p>
        </div>
        <div class="flex flex-row gap-1">
          <p class="text-[#8A8A8A] font-bold text-base">Teléfono:</p>
          <p class="text-[#8A8A8A] text-base">{{ bookingServiceData.booking.customer?.phone }}</p>
        </div>
        <div class="flex flex-row gap-1">
          <p class="text-[#8A8A8A] font-bold text-base">Email:</p>
          <p class="text-[#8A8A8A] text-base">{{ bookingServiceData.booking.customer?.email }}</p>
        </div>
        <div class="flex flex-row gap-1">
          <p class="text-[#8A8A8A] font-bold text-base">Dirección:</p>
          <p class="text-[#8A8A8A] text-base">{{ bookingServiceData.booking?.billing_address?.country }}, {{ bookingServiceData.booking?.billing_address?.city }} - {{ bookingServiceData.booking?.billing_address?.street_name }} {{ bookingServiceData.booking?.billing_address?.description }}</p>
        </div>
      </div>
    </div>
  </div>
</div>
